<template>
    <div class="mh-middle">
		<div class="mh-middle-inner">
			<ContentTitle title="Time Clock" />

			<TimeClock :records="timeClockShifts" @save-clockin-form="getShifts" @save-clockout-form="getShifts" />
		</div>
    </div>
</template>

<script>
	import ContentTitle from "./partials/ContentTitle"
	import TimeClock from "./partials/TimeClock"
	import moment from "moment"

    export default {
		name: 'TimeClockContent',
        components: {
			ContentTitle,
			TimeClock,
		},
		mounted: function () {
			this.$store.dispatch("Intervals/set", { name: "TimeClockGetShifts", callback: this.getShifts, timeout: 60000 })
		},
		destroyed: function () {
			this.$store.commit("Intervals/clear", "TimeClockGetShifts")
		},
		watch: {
			customers: {
				immediate: true,
				handler(newValue, oldValue) {
					if (newValue.length > 0) {
						this.getShifts()
					}
				}
			}
		},
		computed: {
			customers: function () {
				return this.$store.state.Customers.customers
			},
			timeClockShifts: function () {
				return this.$store.state.Shifts.timeClockShifts
			}
		},
        methods: {
			getShifts: function () {
				var now = moment()

				this.$store.dispatch(
					"Shifts/getShiftsForRange",
					{
						fromDate: now.startOf('isoWeek').format('YYYY-MM-DD'),
						toDate: now.add(14, 'days').format('YYYY-MM-DD'),
						showLoading: true
					}
				)
			}
        }
    };
</script>

<style scoped>
</style>